import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import configData from "config.json"
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { AprobarSolicitudesHEDTO } from "../Revisar Solicitudes Horas Extras/typesAprobarSolicitudHE";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { InfoDoc } from "./typesDocumentoPagoEspolHE";

export async function VistaPreviaPagoEspol(estado: string, mes: number, anio: number, idDocumento: number) {
    const url = `${configData.SERVER_URL}AprobacionSolicitudesTH/vistaDocumentoporRefArchivo/${estado}/${mes}/${anio}/${idDocumento}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}

export async function FirmarDocumentoPE(datosRequest: FormData, idDocumento: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleSolicitudesAprobadasHEDTO: AprobarSolicitudesHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleSolicitudesAprobadasHEDTO }


    const url = `${configData.SERVER_URL}AprobacionSolicitudesTH/FirmaDocPagoEspolAutoridades/${idDocumento}`;
    try {
        const respuesta = await axios.post(url, datosRequest, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleSolicitudesAprobadasHEDTO = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleSolicitudesAprobadasHEDTO,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function ObtenerDocumentos(anio: number){
    var respuesta: ResponseRequestGeneric<InfoDoc[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${configData.SERVER_URL}AprobacionSolicitudesTH/obtenerDocumentos/${anio}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: InfoDoc[] | undefined = responseAxios.data;
        
        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch(error) {
        respuesta = hadleAxiosErrorResponse<InfoDoc[]>(error)
    }
    return respuesta
}

export async function ReversarDocumento(idDocumento: number){
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var datos = "";

    const url = `${configData.SERVER_URL}AprobacionSolicitudesTH/ReversarDocumento/${idDocumento}`;
    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url,datos,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        infoResponse = {
            status: respuesta.status
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}